import dayjs from 'dayjs';
import cx from 'classnames';
import { Tooltip } from 'primereact/tooltip';

import { ColumnDescription } from '@/components/common/ui/table/ColumnDescription';
import { IconBook } from '@/components/icons';
import { LessonItemType } from '@/types/lesson';
import LessonDefaultImg from '@/assets/images/lesson-default-image.png';

/**
 * Lesson columns for the mentor's read-only screen.
 *
 * Deliberately NOT reusing LessonListColumns: that one carries the priority
 * editing machinery (10 parameters) the mentor never uses. Three columns are
 * left out on purpose — No/priority and 担当者 carry no meaning for a mentor,
 * and the action column would offer writes the mentor is not allowed.
 */
export const MentorLessonColumns = (
  t: any,
  onOpenProgress?: (rowData: LessonItemType) => void,
): ColumnDescription[] => [
  {
    dataField: 'name',
    text: t('lesson.name'),
    classname: 'min-w-[200px]',
    formatter: (rowData) => (
      <>
        <Tooltip target={`.tooltip-lesson-name-${rowData.id}`}>
          {rowData.name}
        </Tooltip>
        <div
          className={cx(
            'line-clamp-2 break-word',
            `tooltip-lesson-name-${rowData.id}`,
          )}
        >
          {rowData.name}
        </div>
      </>
    ),
  },
  {
    dataField: 'thumbnail_url',
    text: t('lesson.thumbnail'),
    classname: 'min-w-[115px]',
    formatter: (rowData) => (
      <div className="w-[42px] h-[42px]">
        <img
          className="w-[100%] h-[100%] object-cover rounded-[8px]"
          src={rowData.thumbnail_url || LessonDefaultImg}
          alt=""
        />
      </div>
    ),
  },
  {
    dataField: 'description',
    text: t('lesson.description'),
    classname: 'min-w-[200px] w-[460px]',
    headerClassname: 'min-w-[200px] w-[460px]',
    formatter: (rowData) => (
      <div className="line-clamp-2 break-word">{rowData.description}</div>
    ),
  },
  {
    dataField: 'created_at',
    text: t('lesson.create_date'),
    classname: 'w-[140px]',
    formatter: (rowData) => (
      <div>
        {rowData.created_at
          ? dayjs(rowData.created_at.toString()).format('YYYY/MM/DD')
          : ''}
      </div>
    ),
  },
  {
    dataField: 'full_name_kanji',
    text: t('lesson.creator'),
    classname: 'min-w-[110px] w-[200px]',
    formatter: (rowData: any) => (
      <>
        <Tooltip target={`.tooltip-creator-${rowData.id}`}>
          <div>{rowData?.creator?.full_name_kanji || ''}</div>
        </Tooltip>
        <div
          className={cx(
            'line-clamp-2 break-word',
            `tooltip-creator-${rowData.id}`,
          )}
        >
          <div>{rowData?.creator?.full_name_kanji || ''}</div>
        </div>
      </>
    ),
  },
  {
    dataField: '',
    text: t('lesson.progress'),
    classname: 'min-w-[80px]',
    headerClassname: 'text-center',
    formatter: (rowData) => (
      <div
        className="flex justify-center w-full text-primary-500 cursor-pointer"
        onClick={() => onOpenProgress?.(rowData as LessonItemType)}
      >
        <IconBook />
      </div>
    ),
  },
];
